// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bat_a"};